// API utility for backend communication
const API_BASE = "https://truplis.com/api";
// const API_BASE = "http://localhost:8000/api";

export async function fetchBrokerages({
  search = "",
  lat = null,
  lng = null,
  limit = 20,
  offset = 0,
  rankStart,
  rankEnd,
  buildingType, // NEW
} = {}) {
  let url = `${API_BASE}/brokerages`;
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (lat != null && lng != null) {
    params.append("lat", lat);
    params.append("lng", lng);
  }
  if (limit != null) params.append("limit", limit);
  if (offset != null) params.append("offset", offset);
  if (rankStart != null) params.append("rankStart", rankStart);
  if (rankEnd != null) params.append("rankEnd", rankEnd);
  if (buildingType) params.append("buildingType", buildingType); // pass buildingType

  const res = await fetch(`${url}?${params.toString()}`);
  if (!res.ok) throw new Error("Failed to fetch brokerages");
  return res.json();
}

export async function fetchBrokerageDetail(id) {
  const res = await fetch(`${API_BASE}/brokerages/${id}`);
  if (!res.ok) throw new Error("Failed to fetch brokerage detail");
  return res.json();
}

export async function getCoordinate(address) {
  const params = new URLSearchParams({ address });
  const res = await fetch(`${API_BASE}/coordinates?${params.toString()}`);
  if (!res.ok) throw new Error("Failed to get coordinates");
  return res.json();
}
